// removed by extract-text-webpack-plugin
module.exports = {"title":"app-pages-ResendVerificationEmail-NotificationModal-__NotificationModal___1QrPD","error":"app-pages-ResendVerificationEmail-NotificationModal-__NotificationModal___3sDzl","notification":"app-pages-ResendVerificationEmail-NotificationModal-__NotificationModal___1uXpl","dialog":"app-pages-ResendVerificationEmail-NotificationModal-__NotificationModal___1y4b7"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/ResendVerificationEmail/NotificationModal/NotificationModal.css
// module id = 2506
// module chunks = 0